export const APIURL = {
  login: 'admin/login',
  forgotPassword: 'admin/password/forget',
  forgotClientPassword: 'password/forget',
  changePassword: 'admin/password/reset',
  clientNotExist: 'admin/contact-support',
};
